/** Valid tXAI (series 1) token IDs: before-cap roots and their split/merge children. */
const VALID_TXAI_TOKEN_IDS = new Set<number>([
  0, 2, 3, 4, 5, 6, 7, 8, 10, 11, 12, 14, 15, 17, 18, 19, 20, 21, 22, 24, 25, 26, 27, 28,
  29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50,
  51, 52, 54, 55, 56, 57, 58, 59, 60, 62, 63, 64, 65, 66, 68, 69, 71, 72, 73, 74, 75, 78,
  79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100,
  101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117,
  118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 133, 134, 135,
  137, 138, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154,
  155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171,
  172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 184, 185, 186, 187, 188, 189,
  190, 191, 192, 193, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207,
  208, 210, 211, 212, 213, 214, 225, 234, 235, 236, 240, 241, 242, 243, 244, 246, 247,
  249, 250, 251, 252, 334, 335, 336, 337, 339, 340, 342, 344, 346, 347, 348, 349, 350,
  352, 353, 354, 356, 358, 359, 360, 361, 362, 363, 366, 368, 369, 370, 371, 372, 373,
  374, 376, 377, 378, 379, 380, 381, 382, 383, 384, 387, 388, 389, 391, 392, 393, 394,
  395, 396, 397, 398, 399, 400, 401, 402, 403, 404, 405, 406, 407, 408, 409, 417, 418,
  419, 420, 421, 422, 425, 426, 427, 428, 429, 430, 431, 432, 433, 434, 435, 436, 437,
  438, 439, 440, 441, 442, 443, 444, 445, 446, 447, 448, 449, 450, 451, 452, 453, 454,
  455, 456, 457,
])

export const TXAI_NFT_ADDRESS = '0xCB7A78C0B4F3A1cBa6FD31A174e0DD155E767443'
export const TXAI2_NFT_ADDRESS = '0x8F985f94A26a791984d05caAb386054A4EA5e22a'

export const TXAI_INVALID_SLICE_INFO =
  'This investment can no longer be fulfilled. A structured recovery process is actively underway to refund 100% of your original invested principal. An initial portion has already been credited to your account, and the remaining funds will be distributed automatically as they become available.'

function normalizeAddress(value?: string | null): string {
  return (value ?? '').trim().toLowerCase()
}

function normalizeFundUrlId(value?: string | null): string {
  return (value ?? '').trim().toLowerCase()
}

export function getStrapiFundUrlId(
  meta?: {
    fundUrlId?: string
    attributes?: { fundUrlId?: string }
  } | null,
): string {
  return meta?.fundUrlId || meta?.attributes?.fundUrlId || ''
}

export function isTxaiSeries2Fund(
  fundUrlId?: string | null,
  nftAddress?: string | null,
): boolean {
  if (normalizeAddress(nftAddress) === TXAI2_NFT_ADDRESS.toLowerCase()) return true
  const id = normalizeFundUrlId(fundUrlId)
  if (!id.includes('txai')) return false
  return (
    id.includes('round2') ||
    id.includes('round-2') ||
    id.includes('series2') ||
    id.includes('series-2') ||
    id === 'txai2'
  )
}

export function isTxaiSeries1Fund(
  fundUrlId?: string | null,
  nftAddress?: string | null,
): boolean {
  if (isTxaiSeries2Fund(fundUrlId, nftAddress)) return false
  if (normalizeAddress(nftAddress) === TXAI_NFT_ADDRESS.toLowerCase()) return true
  return normalizeFundUrlId(fundUrlId) === 'txai'
}

export function isTxaiFund(
  fundUrlId?: string | null,
  nftAddress?: string | null,
): boolean {
  return (
    isTxaiSeries1Fund(fundUrlId, nftAddress) || isTxaiSeries2Fund(fundUrlId, nftAddress)
  )
}

export function isTxaiSplitMergeDisabled(
  fundUrlId?: string | null,
  nftAddress?: string | null,
): boolean {
  return isTxaiFund(fundUrlId, nftAddress)
}

export function isValidTxaiSeries1TokenId(tokenId: bigint | number | string): boolean {
  return VALID_TXAI_TOKEN_IDS.has(Number(tokenId))
}

export function isInvalidTxaiSlice(
  tokenId: bigint | number | string,
  fundUrlId?: string | null,
  nftAddress?: string | null,
): boolean {
  if (isTxaiSeries2Fund(fundUrlId, nftAddress)) return true
  if (isTxaiSeries1Fund(fundUrlId, nftAddress)) return !isValidTxaiSeries1TokenId(tokenId)
  return false
}
